// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import GenerateCOA from './pages/GenerateCOA';
import Certificates from './pages/Certificates';
import Sample from './pages/Sample';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import VerifyCertificate from './pages/VerifyCertificate';

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sample" element={<Sample />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Public — no login required, this is what the QR code links to */}
            <Route path="/certificados/:certId" element={<VerifyCertificate />} />

            <Route path="/dashboard"        element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/generate"         element={<ProtectedRoute><GenerateCOA /></ProtectedRoute>} />
            <Route path="/certificates"     element={<ProtectedRoute><Certificates /></ProtectedRoute>} />
            <Route path="/certificates/:id" element={<ProtectedRoute><Certificates /></ProtectedRoute>} />
            <Route path="/settings"         element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/admin"            element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
